import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { IPartner } from 'clickNgo/entities/partner/models'
import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'
import { MarketApi } from 'core/classes/services/api/MarketApi'

export const useCheckRegionAccess = ({ region, entryId }: IPartner): boolean => {
  const user = useSelector(selectUser)
  return useMemo(
    () => Boolean(entryId && region && region !== MarketApi.getRegion(user.geoMarket).Region),
    [entryId, region, user.geoMarket]
  )
}
